import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography,
  ListItemText,
  Box,
} from '@mui/material';
import { useState } from 'react';
import { YoutubeEmbed } from '@shared/components/youtube-embed';

export const TutorialsList = ({
  tours,
}: {
  tours: { id: string; title: string; description: string; videoUrl?: string }[];
}) => {
  const [selectedTour, setSelectedTour] = useState<{ url: string; title: string } | null>(null);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', maxHeight: '70vh' }}>
      {selectedTour && <YoutubeEmbed videoUrl={selectedTour.url} title={selectedTour.title} />}
      <List disablePadding sx={{ overflowY: 'auto', flex: 1 }}>
        {tours.map((tour, index) => (
          <TutorialsListItem
            key={tour.id}
            tour={tour}
            index={index}
            setSelectedTour={setSelectedTour}
          />
        ))}
        <TutorialsListItem
          disabled={true}
          key={'tymy'}
          tour={{
            id: 'tymy',
            title: 'Týmy',
            description: 'Jak spravovat a organizovat týmy ve vašem salonu.',
          }}
          index={7}
          setSelectedTour={setSelectedTour}
        />
      </List>
    </Box>
  );
};

const TutorialsListItem = ({
  tour,
  index,
  disabled,
  setSelectedTour,
}: {
  tour: { id: string; title: string; description: string; videoUrl?: string };
  index: number;
  disabled?: boolean;
  setSelectedTour: React.Dispatch<React.SetStateAction<{ url: string; title: string } | null>>;
}) => {
  return (
    <ListItem
      key={tour.id}
      divider
      disablePadding
      onClick={e => {
        if (disabled) return;
        e.stopPropagation();
        setSelectedTour({ url: tour.videoUrl!, title: tour.title });
      }}
    >
      <ListItemButton sx={{ pr: tour.videoUrl ? 6 : undefined }}>
        <ListItemIcon sx={{ minWidth: 30 }}>
          <Typography
            variant="body1"
            color={disabled ? 'text.disabled' : 'primary'}
            fontWeight={700}
          >
            {index + 1}
          </Typography>
        </ListItemIcon>
        <ListItemText
          slotProps={{
            secondary: { sx: { fontSize: '0.675rem' } },
            primary: { sx: { fontSize: '0.775rem', fontWeight: 'bold' } },
          }}
          primary={tour.title}
          secondary={tour.description}
        />
      </ListItemButton>
    </ListItem>
  );
};
